import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import { Theme, TypeAhead } from '@spoiler-alert/ui-library';
import { createUseStyles } from 'react-jss';
import { SiteHierarchyByRootSiteQuery, SiteNameTypeAheadQuery } from '../../graphql/queries';
import { TitleService } from '../../services';
import { Breadcrumbs } from '../../store';
import Tabs from '../../components/tabs/tabs';
import SiteList from './site-list';
import SiteListMap from './site-list-map';

const useStyles = createUseStyles({
  wrap: {
    position: 'relative',
  },
  mapContainer: {
    width: '100%',
    height: 400,
    border: `2px solid ${Theme.greyDark}`,
    overflow: 'hidden',
  },
});

const SiteHierarchy = ({ match, history }) => {
  const classes = useStyles();
  const orgSiteId = match.params.siteId;
  const { data, loading } = useQuery(SiteHierarchyByRootSiteQuery, { variables: { orgSiteId } });

  const sitesList = useMemo(() => data?.siteHierarchyByRootSite || [], [data]);

  const handleSearchType = (value) => {
    if (!value?.result) return;
    if (value.result.siteType === 'FACILITY') {
      history.push(`/sites/${value.result.rootSite}/${value.result._id}`);
    } else {
      history.push(`/sites/${value.result._id}/${value.result._id}`);
    }
  };

  useEffect(() => {
    const orgSite = sitesList.find((s) => s.siteType === 'ORGANIZATION');
    const siteName = orgSite ? orgSite.siteName : 'Site';
    TitleService.setTitles('Inspecting Site Hierarchy');
    Breadcrumbs.set([
      {
        url: '/sites',
        title: 'Sites Administration',
      },
      {
        url: `/sites/${orgSiteId}`,
        title: `${siteName} Hierarchy`,
      },
    ]);
  }, [orgSiteId, sitesList]);

  return (
    <div className={classes.wrap}>
      <TypeAhead query={SiteNameTypeAheadQuery} queryName="siteNameTypeAheadQuery" onChange={handleSearchType} />
      <Tabs
        basename={`/sites/${orgSiteId}`}
        panes={[
          { label: 'Show Site List', path: '', Component: SiteList },
          { label: 'Show Map', path: 'map', Component: SiteListMap },
        ]}
        sitesList={sitesList}
        loading={loading}
        history={history}
        orgSiteId={orgSiteId}
      />
    </div>
  );
};

SiteHierarchy.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      siteId: PropTypes.string,
    }),
  }),
  history: PropTypes.object,
};

export default SiteHierarchy;
